import { useEffect, useState } from 'react'
import { getProfileApi } from '../api/api'

export default function Profile() {
  const [profile, setProfile] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    getProfileApi()
      .then((res) => setProfile(res.data?.data || res.data))
      .catch(()=>setError('Failed to load profile'))
  }, [])

  if (error) return <div className="card error">{error}</div>
  if (!profile) return <div className="card">Loading...</div>

  return (
    <div className="card">
      <h2>Profile</h2>
      <div className="grid-2">
        <div><strong>Name:</strong> {profile.userName || '-'}</div>
        <div><strong>ID:</strong> {profile.tallyUserId || '-'}</div>
        <div><strong>Email:</strong> {profile.userEmail || '-'}</div>
        <div><strong>Contact:</strong> {profile.contactNumber || '-'}</div>
        <div><strong>Status:</strong> {profile.status === 1 ? 'Active' : 'Inactive'}</div>
      </div>
    </div>
  )
}
